export const positionTakeoverModal = (baseRef, modalBackdropRef, modalBodyRef, viewportWidth, viewportHeight) => {
  const modalBase = baseRef.current;
  const modalBackdrop = modalBackdropRef.current;
  const modalBody = modalBodyRef.current;

  // Disable scroll on parent document
  setBodyScroll(false);
  
  // Get position of the global modal container
  const modalBaseBounds = modalBase.getBoundingClientRect();

  // Calculate modal backdrop styles
  const modalBackdropStyles = {
    opacity: 1,
    width: `${viewportWidth}px`,
    height: `${viewportHeight}px`,
    left: `-${modalBaseBounds.left}px`,
    top: `-${modalBaseBounds.top}px`,
  };

  // Calculate modal body styles
  const x = ((viewportWidth - modalBody.clientWidth) / 2) - modalBaseBounds.left;
  const y = ((viewportHeight - modalBody.clientHeight) / 2) - modalBaseBounds.top;
  const modalBodyStyles = {
    opacity: 1,
    transform: `translate(${x}px, ${y}px)`
  };
  
  // Apply styles
  Object.assign(modalBackdrop.style, modalBackdropStyles);
  Object.assign(modalBody.style, modalBodyStyles);
};

export const clearTakeoverModal = modalBodyRef => {
  setBodyScroll(true);
  modalBodyRef.current.style = {};
};

export const setBodyScroll = scroll => Object.assign(document.body.style, {
  overflowY: scroll ? 'auto' : 'hidden'
});
